import type { ComponentPropsWithRef } from "react";

export const ThumbsDownIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.88 19.28" {...props}>
    <g data-name="Group 97238">
      <path
        data-name="Path 246184"
        d="M13.3 19.491a.7.7 0 0 1-1.144-.077l-2.728-4.547a2.957 2.957 0 0 0-2.535-1.435H4.447V4.247H16.56a1.069 1.069 0 0 1 1.032.788l1.921 7.046a1.069 1.069 0 0 1-1.032 1.351h-4.6a1.547 1.547 0 0 0-1.482 1.992l1.029 3.43a.7.7 0 0 1-.128.637zm-2.762.894a2.585 2.585 0 0 0 4.693-2.073l-.9-2.993h4.148a2.957 2.957 0 0 0 2.852-3.735l-1.918-7.045A2.956 2.956 0 0 0 16.56 2.36H4.108A1.548 1.548 0 0 0 2.56 3.908v9.864a1.548 1.548 0 0 0 1.547 1.548h2.786a1.069 1.069 0 0 1 .917.519z"
        transform="translate(-2.56 -2.36)"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        data-name="Path 246185"
        d="M7.026 21.64a.944.944 0 0 0 .944-.94V9.625a.944.944 0 1 0-1.887 0V20.7a.944.944 0 0 0 .943.94z"
        transform="translate(-2.56 -8.681)"
        fill="currentColor"
        fillRule="evenodd"
      />
    </g>
  </svg>
);
